import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import '../dashboard/Dashboard.css';
import './ProductsPage.css';
import CreateBusinessHeader from '../business/components/CreateBusinessHeader';
import ProductsSection from '../dashboard/components/ProductsSection';

function ProductsPage() {
  const navigate = useNavigate();
  const { branchId } = useParams();

  const selectedBranchId =
    branchId && branchId !== 'store' ? branchId : null;

  const handleBack = () => {
    navigate(`/branch/${branchId || 'store'}`);
  };

  return (
    <div className="products-page-root">
      <CreateBusinessHeader
        title="Продукты"
        subtitle=""
        onBack={handleBack}
      />

      <main className="products-page-content">
        <ProductsSection
          selectedBranchId={selectedBranchId}
        />
      </main>

      <footer className="main-page-footer">
        <button
          type="button"
          className="main-page-addButton"
          onClick={() => navigate('/product/create')}
        >
          + Добавить продукт
        </button>
      </footer>
    </div>
  );
}

export default ProductsPage;
